var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardWidgetLineStack',{staticClass:"widget-redditivita",attrs:{"title":"Analisi Redditività","dataY":_vm.dataY,"dataX":_vm.dataX,"legendData":['EBITDA', 'Risultato Netto']}})}
var staticRenderFns = []

export { render, staticRenderFns }